import { Injectable } from '@angular/core';
import { SessionStorageService } from '@app/shared/services/session-storage.service';
import { Guid } from 'guid-typescript';

@Injectable({
    providedIn: 'root'
})
export class AppSessionService {
    readonly appId = 'appId';
    readonly appName = 'appName';
    readonly rootappid = 'rootappid';

    constructor(private readonly storage: SessionStorageService) {

    }

    // set root app id in session storage
    public setRootAppId(rootAppId: string): void {
        this.storage.set(this.rootappid, rootAppId);
    }
    // set appid in session storage, and remove case and plan alternate name from session storage
    public setAppId(appId: string): void {
        this.storage.set(this.appId, appId);
        this.storage.remove('caseAlternateName');
        this.storage.remove('planAlternateName');
    }
    // set appname in session storage
    public setAppName(appName: string): void {
        this.storage.set(this.appName, appName);
    }
    // get appid from session storage
    public getAppId(): string {
        return this.storage.get(this.appId);
    }
    // get appname from session storage
    public getAppName(): string {
        return this.storage.get(this.appName);
    }
    // set browser session id in session storage
    public setBrowserSession(): void {
        const browserSessionId = window.sessionStorage.getItem('browserSessionId');
        if (browserSessionId === null) {
            window.sessionStorage.setItem('browserSessionId', Guid.create().toString());
        }
    }
    // get browser session id from session storage
    public getBrowserSession(): string {
        const browserSessionId = window.sessionStorage.getItem('browserSessionId');

        return browserSessionId;
    }
    // remove browser session id from session storage
    public removeBrowserSession(): void {
        window.sessionStorage.removeItem('browserSessionId');
    }
}